<template>
  <div class="default-page default-page-center text-center">
    <div class="logout-form-icon text-center text-muted mb-2">
      <i class="bi bi-power"></i>
    </div>
    <p class="mb-4">Выйти из системы?</p>
    <button @click="logout" class="btn btn-lg btn-min-width rounded-pill btn-primary">Да, выйти</button>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { UserModel } from "@/models/UserModel";

const router = useRouter();

function logout() {
  UserModel.current().logout();
  router.push('/login');
}
</script>

<style lang="scss" scoped>
.logout-form {
  &-icon {
    font-size: 50px;
    opacity: 0.33;
  }
}
</style>